var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHexbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 267,
    height: 354,
    viewBox: "0 0 267 354",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_37929_18641)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M262 209.895V85.1009C262 76.992 257.668 69.498 250.632 65.4415L142.368 3.04238C135.332 -1.01413 126.664 -1.01413 119.628 3.04238L11.3676 65.4415C4.33208 69.4939 0 76.9879 0 85.1009V209.899C0 218.008 4.33208 225.502 11.3676 229.559L119.628 291.958C126.664 296.014 135.332 296.014 142.368 291.958L250.628 229.559C257.664 225.502 261.996 218.008 261.996 209.899L262 209.895Z",
    fill: "url(#paint0_linear_37929_18641)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7479 224.939V100.123C11.7479 92.0128 16.0708 84.5175 23.0915 80.4603L131.124 18.0504C138.145 13.9932 146.795 13.9932 153.815 18.0504L260.821 79.8659C259.398 73.8606 255.574 68.6065 250.1 65.4449L142.068 3.03509C135.047 -1.02211 126.397 -1.02211 119.376 3.03509L11.3436 65.4449C4.32708 69.498 0 76.9933 0 85.1077V209.927C0 218.038 4.32708 225.533 11.3436 229.59L12.3707 230.184C11.9665 228.488 11.7479 226.734 11.7479 224.943V224.939Z",
    fill: "#EEF1F7"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M262 259.899V135.101C262 126.992 257.668 119.498 250.632 115.442L142.368 53.0424C135.332 48.9859 126.664 48.9859 119.628 53.0424L11.3676 115.442C4.33208 119.498 0 126.992 0 135.101V259.899C0 268.008 4.33208 275.502 11.3676 279.559L119.628 341.958C126.664 346.014 135.332 346.014 142.368 341.958L250.628 279.559C257.664 275.502 261.996 268.008 261.996 259.899H262Z",
    fill: "url(#paint1_linear_37929_18641)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.72011 261.383V136.563C1.72011 128.453 6.04306 120.957 13.0637 116.9L121.096 54.4903C128.117 50.4332 136.767 50.4332 143.788 54.4903L251.82 116.9C253.194 117.693 254.456 118.621 255.611 119.653C254.039 117.907 252.196 116.388 250.1 115.179L142.068 52.7734C135.047 48.7162 126.397 48.7162 119.376 52.7734L11.3436 115.179C4.32295 119.236 0 126.732 0 134.842V259.662C0 266.187 2.80497 272.312 7.55279 276.571C3.85683 272.46 1.71598 267.078 1.71598 261.383H1.72011Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M260.683 129C261.183 130.882 261.451 132.843 261.451 134.844V259.664C261.451 267.774 257.128 275.27 250.107 279.327L142.075 341.737C135.054 345.794 126.404 345.794 119.383 341.737L11.3465 279.327C9.08189 278.018 7.10604 276.351 5.45605 274.424C6.98641 280.177 10.7442 285.188 16.0324 288.242L124.065 350.652C131.086 354.709 139.736 354.709 146.756 350.652L254.789 288.242C261.81 284.185 266.133 276.689 266.133 268.579V143.759C266.133 138.262 264.14 133.053 260.675 129H260.683Z",
    fill: "#EEF1F7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_37929_18641",
    x1: 0,
    y1: 147.5,
    x2: 262,
    y2: 147.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A01C26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB333F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_37929_18641",
    x1: 29.5392,
    y1: 96.2113,
    x2: 232.116,
    y2: 299.133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_37929_18641"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 266.138,
    height: 353.699,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHexbox);
export default __webpack_public_path__ + "static/media/hexbox.b1cce9df47bd565ebb450ec98541da8f.svg";
export { ForwardRef as ReactComponent };